'use client';

import { Link } from '@natu/next-link';
import { Button } from '@natu/ui/Button';
import { ButtonWithEvent } from '@natu/ui/Button/ButtonWithEvent';
import { DynamicIcon } from '@natu/ui/DynamicIcon';
import { usePageContext } from '@natu/utils/PageContextProvider';

import {
  getDescriptiveText,
  getLinkPropsFromStoryblok,
  type StoryblokLink,
} from '../../../../utils';

interface CaseStudyCardButtonProps {
  link?: StoryblokLink;
}

export const CaseStudyCardButton = ({ link }: CaseStudyCardButtonProps) => {
  const resolvedCaseStudyUrl = getLinkPropsFromStoryblok(link);
  const { isArticle } = usePageContext() || {};

  if (!resolvedCaseStudyUrl) return null;

  const { descriptiveText } = getDescriptiveText({
    title: 'Learn more',
    link: resolvedCaseStudyUrl,
  });

  if (isArticle) {
    const isCaseStudy = resolvedCaseStudyUrl?.href?.includes('/portfolio');

    return (
      <ButtonWithEvent
        event={isCaseStudy ? 'E_cta_blog_banner_to_case_study' : 'E_cta_blog_banner_landing'}
        asChild
        size="sm"
        variant="outline-transparent"
        className="w-max"
      >
        <Link className="flex items-center gap-x-2 uppercase" {...resolvedCaseStudyUrl}>
          Learn more
          {descriptiveText && <span className="sr-only">{descriptiveText}</span>}
          <DynamicIcon icon="arrowRight" />
        </Link>
      </ButtonWithEvent>
    );
  }

  return (
    <Button asChild size="sm" variant="outline-transparent" className="w-max">
      <Link className="flex items-center gap-x-2 uppercase" {...resolvedCaseStudyUrl}>
        Learn more
        {descriptiveText && <span className="sr-only">{descriptiveText}</span>}
        <DynamicIcon icon="arrowRight" />
      </Link>
    </Button>
  );
};
